import type { PropsWithChildren } from 'react';
import { useCallback, useMemo, useState } from 'react';

export type Step = string;

export type Steps = Step[];

type StepProps<S> = {
  step: S;
};

export function useMultistepModal<S extends string>(initialStep: S) {
  const [currentStep, setCurrentStep] = useState<S>(initialStep);
  const isStep = useCallback((step: S) => currentStep === step, [currentStep]);

  const Step = useMemo(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    () => ({ step, children }: PropsWithChildren<StepProps<S>>) => isStep(step) ? <>{children}</> : null,
    [isStep],
  );

  return useMemo(() => ({
    goTo: (step: S) => setCurrentStep(step),
    Step,
  }), [Step]);
}
